import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import HealthcareLOGO2 from "../assets/img/HealthcareLOGO2.png";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  NavLink,
} from "react-router-dom";
import { Banner } from "./Banner";
import { Footer } from "./Footer";
import { KeyPoint } from "./KeyPoint";
import { Simple } from "./Simple";
import { Services } from "./Services";
import { ChooseUs } from "./ChooseUs";
import { Process } from "./Process";
import { Treatments } from "./Treatments";
import { Contact } from "./Contact";

export const NavBar = () => {
  const [activeLink, setActiveLink] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const emailAddress = "sharvil.prasad@gmail.com";

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", onScroll);

    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const onUpdateActiveLink = (value) => {
    setActiveLink(value);
  };

  const handleConnectClick = () => {
    window.location.href = `mailto:${emailAddress}`;
  };

  const Home = () => {
    return (
      <div className="App">
        <Banner />
        <KeyPoint />
        <Simple />
        <ChooseUs />
        <Services />
        <Process />
        <Treatments />
        <Contact />
        <Footer />
      </div>
    );
  };

  return (
    <Router>
      <Navbar expand="md" className={scrolled ? "scrolled" : ""}>
        <Container>
          <Navbar.Brand href="/">
            <img src={HealthcareLOGO2} alt="Logo" />
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav">
            <span className="navbar-toggler-icon"></span>
          </Navbar.Toggle>
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              <Nav.Link as={NavLink} to="/" className="navbar-link">
                Our Services
              </Nav.Link>
              {/* <Nav.Link
                href="#product"
                className={
                  activeLink === "product"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("product")}
              >
                Products
              </Nav.Link> */}
              {/* <NavDropdown
                title="Products"
                active={activeLink === "product"} // Update active state
                onClick={() => onUpdateActiveLink("product")}
                menuVariant="light" // Adjust menuVariant for desired style
                className={
                  activeLink === "product"
                    ? "active navbar-link"
                    : "navbar-link"
                }
              >
                <NavDropdown.Item
                  as={NavLink}
                  to="/product1"
                  className="navbar-link"
                >
                  Product 1
                </NavDropdown.Item>
                <NavDropdown.Item href="#category2">Product 2</NavDropdown.Item>
                <NavDropdown.Item href="https://example.com/product3">
                  Product 3
                </NavDropdown.Item>
              </NavDropdown> */}
              <Nav.Link
                href="#aboutus"
                className={
                  activeLink === "aboutus"
                    ? "active navbar-link"
                    : "navbar-link"
                }
                onClick={() => onUpdateActiveLink("aboutus")}
              >
                Departments
              </Nav.Link>
              <Nav.Link as={NavLink} to="/contact" className="navbar-link">
                Blogs
              </Nav.Link>
            </Nav>
            <span className="navbar-text">
              {/* <div className="social-icon">
                <a
                  href="https://www.linkedin.com/in/sharvil-prasad-bbbb81152"
                  target="_blank"
                >
                  <img src={navIcon1} alt="" />
                </a>
                <a href="https://twitter.com/sharvs_" target="_blank">
                  <img src={navIcon2} alt="" />
                </a>
                <a
                  href="https://www.instagram.com/sharvilprasad/"
                  target="_blank"
                >
                  <img src={navIcon3} alt="" />
                </a>
              </div> */}
              <button to="#" onClick={handleConnectClick} className="vvd">
                <span>Contact Us</span>
              </button>
            </span>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact" element={<Home />} />
        <Route path="/product1" element={<Home />} />
      </Routes>
    </Router>
  );
};
